import { render, staticRenderFns } from "./coursePage.vue?vue&type=template&id=75919be4&scoped=true"
import script from "./coursePage.vue?vue&type=script&lang=js"
export * from "./coursePage.vue?vue&type=script&lang=js"
import style0 from "./coursePage.vue?vue&type=style&index=0&id=75919be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75919be4",
  null
  
)

export default component.exports